import React, { createContext, useContext, useState, ReactNode } from 'react';

export type PrizeDisplayMode =
  | 'logo-label'
  | 'label-only'
  | 'logo-only'
  | 'logo-background'
  | 'logo-background-only';

export type PrizeLabelTextColor = 'white' | 'black';
export type PrizeResultType = 'win' | 'fail';

export interface Prize {
  id: string;
  label: string;
  color: string;
  Qte: number;
  valeur: string;
  logoUrl?: string;
  logo?: string;
  displayMode?: PrizeDisplayMode;
  wheelLogoScale?: number | string;
  labelTextColor?: PrizeLabelTextColor;
  resultType?: PrizeResultType;
  order?: number | string;
  wheelBackgroundColor?: string;
  wheelBackgroundColor2?: string;
}

interface DataContextProps {
  data: Prize[];
  setData: React.Dispatch<React.SetStateAction<Prize[]>>;
}

const DataContext = createContext<DataContextProps>({
  data: [],
  setData: () => {},
});

export const DataContextProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [data, setData] = useState<Prize[]>([]);

  return (
    <DataContext.Provider value={{ data, setData }}>
      {children}
    </DataContext.Provider>
  );
};

export const useData = () => useContext(DataContext);

export { DataContext };
